import React from 'react'
import {
    mdiAccountHardHatOutline,
    mdiLockOutline
} from "@mdi/js"
import MdiIcon from "@mdi/react"
import { Tooltip } from './'

export default function IsAssignedIcon({ theme, isInverted, iconClass, locale, isLocked, big, isHidden}) {
    if (isHidden) return null

    if (isLocked) {
        return (
            <MdiIcon className={iconClass} path={mdiLockOutline} size={big ? '30px' : '20px'} color={isInverted ? theme.textPrimaryReverted : theme.secondary} />
        )
    }
    return (
        <Tooltip hover text={locale.common.assigned}>
            <MdiIcon className={iconClass} path={mdiAccountHardHatOutline} size={big ? '30px' : '20px'} color={isInverted ? theme.textPrimaryReverted : theme.quaternary} />
        </Tooltip>
    )
}
